import {
  BrowserRouter
} from "react-router";
import { App as AntdApp } from 'antd';
import './App.css';
import AppRouter from "@/routers";

const App = () => {
  return (
    <AntdApp>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AntdApp>
  );
}



export default App;
